module.exports = __webpack_public_path__ + "3a63fbb6995285da8aa04c1380a2c3b8.svg";